module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"active\"><a id=\"groupCommon\" name=\"common\" data-toggle=\"tab\" href=\"#common\">Common</a></li>\r\n<li class=\"\"><a id=\"groupForm\" name=\"form\" data-toggle=\"tab\" href=\"#form\">App</a></li>\r\n<li class=\"\"><a id=\"groupGeneral\" name=\"general\" data-toggle=\"tab\" href=\"#general\">General</a></li>\r\n<li class=\"\"><a id=\"groupIntegration\" name=\"integration\" data-toggle=\"tab\" href=\"#integration\">Integration</a></li>\r\n<li class=\"\"><a id=\"groupObjects\" name=\"objects\" data-toggle=\"tab\" href=\"#objects\">Objects</a></li>\r\n<li class=\"\"><a id=\"groupWorkflow\" name=\"workflow\" data-toggle=\"tab\" href=\"#workflow\">Workflow</a></li>\r\n<li class=\"\"><a id=\"groupAll\" name=\"all\" data-toggle=\"tab\" href=\"#all\">All</a></li>")
  }
  return __output;

}